import { Crown, Heart, Crosshair } from "lucide-react";
import { hunterTier } from "../lib/constants";

// Public recognition badges shown next to a user's name across the site.
export const UserBadges = ({ supporter, tipper, hunter, busts, size = 11 }) => {
  const tier = hunter ? hunterTier(busts || 1) : null;
  return (
    <>
      {supporter && (
        <span title="Supporter" data-testid="badge-supporter" className="inline-flex items-center gap-0.5 rounded bg-[#FFB800]/15 px-1.5 py-0.5 text-[10px] font-bold uppercase text-[#FFB800]">
          <Crown size={size} /> Supporter
        </span>
      )}
      {tipper && (
        <span title="Tipper" data-testid="badge-tipper" className="inline-flex items-center gap-0.5 rounded bg-[#FF6B9D]/15 px-1.5 py-0.5 text-[10px] font-bold uppercase text-[#FF6B9D]">
          <Heart size={size} /> Tipper
        </span>
      )}
      {tier && (
        <span
          title={`${tier.label} — ${busts || 0} confirmed bust${busts === 1 ? "" : "s"}`}
          data-testid="badge-hunter"
          className="inline-flex items-center gap-0.5 rounded px-1.5 py-0.5 text-[10px] font-bold uppercase"
          style={{ color: tier.color, backgroundColor: `${tier.color}26` }}
        >
          <Crosshair size={size} /> {tier.short}{busts ? ` ·${busts}` : ""}
        </span>
      )}
    </>
  );
};
